import { combineReducers } from 'redux';

import * as types from 'modules/campaigns/actionTypes';
import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  ready: boolean,
 *  sending: boolean,
 *  scheduling: boolean,
 *  campaignId: string,
 * }} CampaignUIModalSendReducer
 */

export default combineReducers({
  open: createReducer(false, {
    [types.OPEN_SEND_MODAL]: () => true,
    [types.CLOSE_SEND_MODAL]: () => false,
    [types.SEND_CAMPAIGN_SUCCESS]: () => false,
    [types.PATCH_CAMPAIGN_SEND_DATE_SUCCESS]: () => false,
    [types.DELETE_CAMPAIGN_SEND_DATE_SUCCESS]: () => false,
  }),
  ready: createReducer(false, {
    [types.SEND_MODAL_READY]: () => true,
    [types.CLOSE_SEND_MODAL]: () => false,
    [types.SEND_CAMPAIGN_SUCCESS]: () => false,
    [types.PATCH_CAMPAIGN_SEND_DATE_SUCCESS]: () => false,
    [types.DELETE_CAMPAIGN_SEND_DATE_SUCCESS]: () => false,
  }),
  campaignId: createReducer(null, {
    [types.OPEN_SEND_MODAL]: (_, { payload: campaignId }) => campaignId,
    [types.CLOSE_SEND_MODAL]: () => null,
    [types.SEND_CAMPAIGN_SUCCESS]: () => null,
    [types.PATCH_CAMPAIGN_SEND_DATE_SUCCESS]: () => null,
    [types.DELETE_CAMPAIGN_SEND_DATE_SUCCESS]: () => null,
  }),
  sending: loading(types.SEND_CAMPAIGN),
  scheduling: loading(types.PATCH_CAMPAIGN_SEND_DATE),
  unScheduling: loading(types.DELETE_CAMPAIGN_SEND_DATE),
});
